export default __webpack_public_path__ + "static/media/user-icon.7aa9a4de.svg";